import React, { useMemo } from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { PreLoader } from './PreLoader';
import { useTranslation } from 'react-i18next';

const Wrapper = () => {
  return useMemo(() => <PreLoader />, []);
};

export const VDP = () => {
  const { t } = useTranslation();
  return (
    <>
      <DocumentHead title={t('Pushed to VDP')} />
      <PageTemplate main={<Wrapper />} />
    </>
  );
};
